/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/no-array-index-key */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { GeneralSchema } from '@ashleynexvelsolutions/general-schema'
import { PageSpecificSchema } from '@ashleynexvelsolutions/page-specific-schema'
import { Seo } from '@ashleynexvelsolutions/seo'
import { css } from '@emotion/react'
import { graphql, Link } from 'gatsby'
import { jsx } from 'theme-ui'
import { Box, Container, GatsbyLink, Heading, Html } from '../components/elements'
import Layout from '../components/layout'
import { SeoFunction, GeneralSchemaFunction, PageSpecificSchemaFunction } from '../DataImports'

const Blog = ({
  data,
  pageContext: { totalPages, currentPage, previousPagePath, nextPagePath },
}) => {
  const posts = data.allWpPost.nodes

  const currentPage2 = currentPage

  let endPagination =
    currentPage === totalPages ? totalPages : 3 * (Math.floor(currentPage / 4) + 1)
  endPagination = endPagination >= totalPages ? totalPages : endPagination
  let startPagination = endPagination - 2
  startPagination = startPagination <= 1 ? 1 : startPagination

  let endPagination2 =
    currentPage2 === totalPages ? totalPages : 6 * (Math.floor(currentPage / 7) + 1)
  endPagination2 = endPagination2 >= totalPages ? totalPages : endPagination2
  let startPagination2 = endPagination2 - 5
  startPagination2 = startPagination2 <= 1 ? 1 : startPagination2

  const range = (start, stop, step) =>
    Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)
  const pagination = range(startPagination, endPagination, 1)

  const range2 = (start, stop, step) =>
    Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)
  const pagination2 = range2(startPagination2, endPagination2, 1)

  if (!posts.length) {
    return (
      <p>No blog posts found. Add posts to your WordPress site and they&apos;ll appear here!</p>
    )
  }

  return (
    <>
      <GeneralSchema {...GeneralSchemaFunction()} />
      <PageSpecificSchema {...PageSpecificSchemaFunction(data)} />
      <Seo {...SeoFunction(data)} />
      <Layout>
        <Container sx={{ mx: 'auto', maxWidth: 1200, my: 3, px: [2, 3, 4] }}>
          <Heading fontSize={[6, 7]} mt={3}>
            {' '}
            Recent Posts{' '}
          </Heading>
          {data.allWpPost.nodes.map((post, i) => {
            return (
              <Box sx={{ width: '95%', my: 4 }} key={i}>
                <GatsbyLink to={`/blog${post.uri}`}>
                  <Heading fontSize={[4, 5]}>{post.title} </Heading>
                </GatsbyLink>
                <Html html={post.excerpt} />
              </Box>
            )
          })}
          <div
            css={css`
              .active {
                color: #d52925;
              }
              .paginationNumbersContainer {
                display: flex;
                justify-content: center;
              }
              .paginationMobile,
              .paginationDesktop {
                display: flex;
                gap: 20px;
              }
              .paginationDesktop {
                display: none;
              }
              @media (min-width: 992px) {
                .paginationDesktop {
                  display: flex;
                }
                .paginationMobile {
                  display: none;
                }
              }
            `}
          >
            <div className="paginationNumbersContainer">
              <div className="paginationMobile">
                {previousPagePath !== null && <Link to={previousPagePath}>Prev</Link>}
                {pagination.map((number, index) => (
                  <Link
                    key={index}
                    to={number === 1 ? `/blog/` : `/blog/${number}`}
                    className={number === currentPage ? 'active pageNum' : 'pageNum'}
                  >
                    <span>{number}</span>
                  </Link>
                ))}
                {nextPagePath !== null && <Link to={nextPagePath}>Next</Link>}
              </div>
              <div className="paginationDesktop">
                {previousPagePath !== null && <Link to={previousPagePath}>Previous Page</Link>}
                {pagination2.map((number, index) => (
                  <Link
                    key={index}
                    to={number === 1 ? `/blog/` : `/blog/${number}`}
                    className={number === currentPage ? 'active pageNum' : 'pageNum'}
                  >
                    <span>{number}</span>
                  </Link>
                ))}
                {nextPagePath !== null && <Link to={nextPagePath}>Next Page</Link>}
              </div>
            </div>
            {currentPage !== totalPages ? (
              <Link to={`/blog/${currentPage + 1}`}>
                <div className="paginationNext" />
              </Link>
            ) : (
              <div className="paginationNext" />
            )}
          </div>
        </Container>
      </Layout>
    </>
  )
}

export const query = graphql`
  query GET_POSTS($offset: Int!, $postsPerPage: Int!) {
    allWpPost(sort: { date: DESC }, limit: $postsPerPage, skip: $offset) {
      nodes {
        uri
        content
        title
        excerpt
      }
    }

    sitePage(path: { eq: "/blog/" }) {
      path
    }
    wp {
      nexvelSchemaMarkup {
        nexvelschema {
          cities {
            city
          }
          services {
            service
            linkToRelevantPageOnYourWebsite
          }
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`

export default Blog
